module.exports = __webpack_public_path__ + "img/orange_042.8537c7c0.png";